import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SOCIAL_SAME_AS } from '../lib/socialLinks';

const SEO = ({
  title = 'Neuralia369 — La inteligencia que piensa contigo',
  description = 'Automatizamos procesos, reducimos costos y multiplicamos tu productividad con soluciones de IA diseñadas para empresas reales.',
  path = '',
  type = 'website',
  keywords = 'IA para empresas, automatización con IA, agentes IA, Neuralia369',
  image: customImage = '',
  schemas = [],
  noindex = false
}) => {
  const siteUrl = process.env.REACT_APP_SITE_URL;
  const url = `${siteUrl}${path}`;
  const image = customImage ? `${siteUrl}${customImage}` : `${siteUrl}/social-preview.svg`;
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Neuralia369",
    "url": siteUrl,
    "inLanguage": ["es", "en"],
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${siteUrl}/blog`,
      "query-input": "required name=search_term_string"
    }
  };
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Neuralia369",
    "url": siteUrl,
    "description": "Inteligencia Artificial para empresas, automatización, agentes IA y plataforma SaaS.",
    "email": "contacto@neuralia369.com",
    "sameAs": SOCIAL_SAME_AS,
    "areaServed": [
      { "@type": "City", "name": "Lima" },
      { "@type": "Country", "name": "Perú" },
      { "@type": "Country", "name": "España" },
      { "@type": "Country", "name": "Puerto Rico" },
      { "@type": "Country", "name": "Brasil" }
    ],
    "knowsAbout": [
      'Sistema multiagente marketing y gestión de empresas',
      'Consultoría IA',
      'CRM clínico',
      'Neuralia369Tesix Perú',
      'Automatización con IA para empresas'
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Calle San Judas 214, Barrio Corazón",
      "addressLocality": "Guayama",
      "postalCode": "00784",
      "addressRegion": "PR",
      "addressCountry": "US"
    }
  };
  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Neuralia Workspace",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "url": `${siteUrl}/precios`,
    "description": "Workspace SaaS para contenido, agentes IA, automatización, vídeo corto y publicación asistida.",
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": "USD",
      "lowPrice": "69",
      "highPrice": "3069"
    }
  };
  const professionalServiceSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Neuralia369",
    "url": url,
    "serviceType": [
      'Sistema multiagente marketing y gestión de empresas',
      'Consultoría IA',
      'CRM clínico',
      'Automatización con IA para empresas'
    ],
    "areaServed": [
      { "@type": "City", "name": "Lima" },
      { "@type": "Country", "name": "Perú" },
      { "@type": "Country", "name": "España" },
      { "@type": "Country", "name": "Puerto Rico" },
      { "@type": "Country", "name": "Brasil" }
    ]
  };
  const allSchemas = [websiteSchema, organizationSchema, softwareSchema, professionalServiceSchema, ...schemas];

  return (
    <Helmet>
      <html lang="es" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={noindex ? 'noindex,nofollow' : 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1'} />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="es" href={url} />
      <link rel="alternate" hrefLang="en" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Neuralia369" />
      <meta property="og:locale" content="es_ES" />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data */}
      {allSchemas.map((schema, index) => (
        <script key={`schema-${index}`} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
};

export default SEO;
